<template>
  <v-container>
    <div class="title-icon">
      <h1 class>{{ $t('ebook.education-title') }}</h1>
      <v-btn icon :href="links.ebook.apprenticeInfo" target="_blank">
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>
    <div class="overline pt-6">{{ $t('fields.apprentice-profession') }}</div>
    <h4>{{ getProfessionName() }}</h4>
    <progressLinear
      class="mt-n2"
      :value="getPercentage(Number(book.bookElementsApprovedCount), Number(book.bookElementsMandatoryCount))"
    ></progressLinear>
    <div class="caption-1">{{ $t('ebook.progress-note') }}</div>
    <p class="pt-2">
      {{ $t('ebook.education-text2') + ' ' + book.bookElementsApprovedCount }}
      {{ $t('ebook.education-text3') + ' ' + book.bookElementsMandatoryCount }}
      {{ $t('ebook.education-text4') }}
    </p>
    <p class="pb-2" v-if="daysFromNow>0">
      <i>{{ $t('ebook.education-text7', {msg1: goingDays, msg2: lastDate, msg3: leftDays}) }}</i>
    </p>
    <p class="pb-2" v-else>
      <i>{{ $t('ebook.education-text7-2', {msg1: goingDays, msg2: lastDate}) }}</i>
    </p>
    <!-- Distance education provider courses list starts here -->
    <DistanceEducationProviderCourses
      class="mt-6"
      v-if="book && book.education"
      :education="book.education"
      @modalToogle="modalToogle"
    />
    <ElementsExpansionPanel
      :elements="book.bookElements"
      :isInstructor="false"
      @modalToogle="modalToogle"
      @elementModalToogle="elementModalClick"
      :apprenticeName="get(book, 'person.firstName', null)"
    ></ElementsExpansionPanel>

    <EbookElementInfoModal
      :show="openElementModal"
      @close="closeElementModal"
      :element="this.dialogElement"
    ></EbookElementInfoModal>
    <EbookProfessionInfoModal :show="openModal" @close="close" :element="this.dialogElement"></EbookProfessionInfoModal>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import API from '@/services/api.js'
import sortBy from 'lodash/sortBy'
import EbookProfessionInfoModal from '@/components/Ebook/Apprentice/EbookProfessionInfoModal'
import EbookElementInfoModal from '@/components/Ebook/EbookElementInfoModal'
import DistanceEducationProviderCourses from '@/components/Ebook/Common/DistanceEducationProviderCourses'
import progressLinear from '@/components/Common/ProgressLinear'
import BottomNav from '@/components/Application/BottomNav'
import ElementsExpansionPanel from '@/components/Common/Ebook/ElementsExpansionPanel'
import find from 'lodash/find'
import get from 'lodash/get'
const SugarDate = require('sugar/date')

// @group Ebook
// Styled EducationStart component
export default {
  name: 'EducationStart',

  props: {
    //setStep: Number
  },

  components: {
    BottomNav,
    EbookProfessionInfoModal,
    progressLinear,
    ElementsExpansionPanel,
    EbookElementInfoModal,
    DistanceEducationProviderCourses
  },

  data() {
    return {
      links: require('../../lib/external-links.json'),
      dialogElement: {},
      openModal: false,
      openElementModal: false,
      book: [],
      lastDate: '',
      goingDays: '',
      leftDays: '',
      daysFromNow: 0
    }
  },

  created() {
    this.init()
  },

  watch: {},

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isApprentice', 'isInstructor']),
    ...mapGetters('basic', ['basicProfessions','hasProfessionOrientations'])
  },

  filters: {},
  methods: {
    get,
    sortBy: sortBy,

    init() {
      if (!(this.$route.params.id || this.currentUser)) {
        this.$router.push('/').catch(() => {})
      } else {
        this.getBook(this.$route.params.id)
      }
    },
    getPercentage(v1, v2) {
      var value = 0
      if (Number(v2) && v2 > 0) {
        return (v1 / v2) * 100
      } else return value
    },
    getProfessionName() {
      if (this.book && this.book.professionId) {
        const p = find(this.basicProfessions, ['id', this.book.professionId])
        return p ? `${p.name}` : ''
      } else {
        return ''
      }
    },
    // @vuese
    // Used to get book by if
    // @arg The argument is integer representing book id
    getBook(id) {
      API.getBook(id)
        .then(res => {
          if (res.data) {
            this.book = res.data
             let isMachineProfession = this.hasProfessionOrientations(this.book.professionId)
            if (isMachineProfession) {
              this.lastDate = SugarDate.Date(this.book.calculatedValidTo).addMonths(6).format("{yyyy}-{MM}-{dd}").raw;
              const educationEndDate = SugarDate.Date(get(res, 'data.education.endDate', new Date())).format('{yyyy}-{MM}-{dd}').raw
              if ( this.lastDate < educationEndDate )    
                this.lastDate = educationEndDate
            } else {
              this.lastDate = SugarDate.Date(this.book.calculatedValidTo).addMonths(12).format("{yyyy}-{MM}-{dd}").raw;
              if(SugarDate.Date(this.book.calculatedValidTo).raw < SugarDate.Date(this.book.education.endDate).raw) {
                this.lastDate = SugarDate.Date(this.book.education.endDate).format("{yyyy}-{MM}-{dd}").raw;
              }
            }

            if (SugarDate.Date(this.book.createdAt).daysAgo() == 1) {
              this.goingDays = SugarDate.Date(this.book.createdAt).daysAgo() + ' ' + this.$t('ebook.education-day')
            } else {
              this.goingDays = SugarDate.Date(this.book.createdAt).daysAgo() + ' ' + this.$t('ebook.education-days')
            }
            this.daysFromNow=SugarDate.Date(this.lastDate).addDays(1).daysFromNow()
            if (SugarDate.Date(this.lastDate).daysFromNow() == 1) {
              this.leftDays = SugarDate.Date(this.lastDate).addDays(1).daysFromNow() + ' ' + this.$t('ebook.education-day')
            } else {
              this.leftDays = SugarDate.Date(this.lastDate).addDays(1).daysFromNow() + ' ' + this.$t('ebook.education-days')
            }
          }
        })
        .catch(error => {
          console.log('Error: ' + error)
        })
    },

    close() {
      this.openModal = !this.openModal
    },
    closeElementModal() {
      this.openElementModal = !this.openElementModal
    },
    elementModalClick(item) {
      this.dialogElement = item
      this.openElementModal = !this.openElementModal
    },
    modalToogle(item) {
      this.dialogElement = item
      this.openModal = !this.openModal
    }
  }
}
</script>
